import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, tap } from 'rxjs';
import { accessWeaponsApi, HttpBaseService }   from '@evento-ng/libs';

@Component({
  selector: 'app-my-requests',
  templateUrl: './my-requests.component.html',
  styleUrls: ['./my-requests.component.scss'],
})
export class MyRequestsComponent implements OnInit {
  requests: any[] = [];
  meta: null;
  page = 1;

  constructor(
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.getMyRequests();
  }

  getMyRequests(): void {
    this.spinner.show();
    firstValueFrom(
      this.dataService
        .get(`${accessWeaponsApi}/my-requests`, {
          params: {
            page: this.page,
          },
        })
        .pipe(
          tap((res) => {
            this.spinner.hide();
            this.requests = res.data;
            this.meta = res.meta;
          })
        )
    );
  }

  goToPage(n: number): void {
    this.page = n;
    this.spinner.show();
    this.getMyRequests();
  }

  onNext(): void {
    this.page++;
    this.spinner.show();
    this.getMyRequests();
  }

  onPrev(): void {
    this.page--;
    this.spinner.show();
    this.getMyRequests();
  }
}
